'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	type: 'HTML_ADVANCED',
	name: 'Html Advanced',
	allowedSections: ['header', 'main', 'footer'],
	disallowedChildren: ['*'],
	category: 'Code',
	props: [{
		name: 'html',
		inputType: 'htmladvanced',
		label: 'Html',
		default: ''
	}]
};